/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cipher_Stage_Orbital_HandoffInputs */

const bn_cipher_stage_orbital_handoff = /** @type {(inputs: Cipher_Stage_Orbital_HandoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অরবিটাল হ্যান্ডঅফ`)
};

const de_cipher_stage_orbital_handoff = /** @type {(inputs: Cipher_Stage_Orbital_HandoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orbitale Übergabe`)
};

const el_cipher_stage_orbital_handoff = /** @type {(inputs: Cipher_Stage_Orbital_HandoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Τροχιακή μεταβίβαση`)
};

const en_cipher_stage_orbital_handoff = /** @type {(inputs: Cipher_Stage_Orbital_HandoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orbital handoff`)
};

const es_cipher_stage_orbital_handoff = /** @type {(inputs: Cipher_Stage_Orbital_HandoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traspaso orbital`)
};

const fr_cipher_stage_orbital_handoff = /** @type {(inputs: Cipher_Stage_Orbital_HandoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relais orbital`)
};

const hi_cipher_stage_orbital_handoff = /** @type {(inputs: Cipher_Stage_Orbital_HandoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कक्षीय हैंडऑफ़`)
};

const hu_cipher_stage_orbital_handoff = /** @type {(inputs: Cipher_Stage_Orbital_HandoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orbitális átadás`)
};

const id_cipher_stage_orbital_handoff = /** @type {(inputs: Cipher_Stage_Orbital_HandoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penyerahan orbital`)
};

const it_cipher_stage_orbital_handoff = /** @type {(inputs: Cipher_Stage_Orbital_HandoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trasferimento orbitale`)
};

const ja_cipher_stage_orbital_handoff = /** @type {(inputs: Cipher_Stage_Orbital_HandoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`軌道ハンドオフ`)
};

const ko_cipher_stage_orbital_handoff = /** @type {(inputs: Cipher_Stage_Orbital_HandoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`궤도 핸드오프`)
};

const nl_cipher_stage_orbital_handoff = /** @type {(inputs: Cipher_Stage_Orbital_HandoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orbitale overdracht`)
};

const pl_cipher_stage_orbital_handoff = /** @type {(inputs: Cipher_Stage_Orbital_HandoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przekazanie orbity`)
};

const pt_cipher_stage_orbital_handoff = /** @type {(inputs: Cipher_Stage_Orbital_HandoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transferência orbital`)
};

const ru_cipher_stage_orbital_handoff = /** @type {(inputs: Cipher_Stage_Orbital_HandoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Орбитальная передача`)
};

const sv_cipher_stage_orbital_handoff = /** @type {(inputs: Cipher_Stage_Orbital_HandoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orbital handoff`)
};

const tr_cipher_stage_orbital_handoff = /** @type {(inputs: Cipher_Stage_Orbital_HandoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yörünge aktarımı`)
};

const uk_cipher_stage_orbital_handoff = /** @type {(inputs: Cipher_Stage_Orbital_HandoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Орбітальна передача`)
};

const vi_cipher_stage_orbital_handoff = /** @type {(inputs: Cipher_Stage_Orbital_HandoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chuyển giao quỹ đạo`)
};

const zh_cipher_stage_orbital_handoff = /** @type {(inputs: Cipher_Stage_Orbital_HandoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`轨道切换`)
};

const zh_hant_cipher_stage_orbital_handoff = /** @type {(inputs: Cipher_Stage_Orbital_HandoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`軌道切換`)
};

/**
* | output |
* | --- |
* | "Orbital handoff" |
*
* @param {Cipher_Stage_Orbital_HandoffInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const cipher_stage_orbital_handoff = /** @type {((inputs?: Cipher_Stage_Orbital_HandoffInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cipher_Stage_Orbital_HandoffInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_cipher_stage_orbital_handoff(inputs)
	if (locale === "de") return de_cipher_stage_orbital_handoff(inputs)
	if (locale === "el") return el_cipher_stage_orbital_handoff(inputs)
	if (locale === "en") return en_cipher_stage_orbital_handoff(inputs)
	if (locale === "es") return es_cipher_stage_orbital_handoff(inputs)
	if (locale === "fr") return fr_cipher_stage_orbital_handoff(inputs)
	if (locale === "hi") return hi_cipher_stage_orbital_handoff(inputs)
	if (locale === "hu") return hu_cipher_stage_orbital_handoff(inputs)
	if (locale === "id") return id_cipher_stage_orbital_handoff(inputs)
	if (locale === "it") return it_cipher_stage_orbital_handoff(inputs)
	if (locale === "ja") return ja_cipher_stage_orbital_handoff(inputs)
	if (locale === "ko") return ko_cipher_stage_orbital_handoff(inputs)
	if (locale === "nl") return nl_cipher_stage_orbital_handoff(inputs)
	if (locale === "pl") return pl_cipher_stage_orbital_handoff(inputs)
	if (locale === "pt") return pt_cipher_stage_orbital_handoff(inputs)
	if (locale === "ru") return ru_cipher_stage_orbital_handoff(inputs)
	if (locale === "sv") return sv_cipher_stage_orbital_handoff(inputs)
	if (locale === "tr") return tr_cipher_stage_orbital_handoff(inputs)
	if (locale === "uk") return uk_cipher_stage_orbital_handoff(inputs)
	if (locale === "vi") return vi_cipher_stage_orbital_handoff(inputs)
	if (locale === "zh") return zh_cipher_stage_orbital_handoff(inputs)
	return zh_hant_cipher_stage_orbital_handoff(inputs)
});